import React, { useContext, useState } from 'react'
import { LocaleContext } from '../routes'
import { BirthDate, CalendarInput } from '../styles/calendar'
import DatePicker from '../views/common/DatePicker'
import { LabelExtra } from '../styles/elements'
import BottomSheet from './common/BottomSheetHint'
import { CalendarIcon } from '../styles/image'
import calendarIcon from '../assets/icons/calendar.svg'

export default ({ onChange, birthdate }) => {
  const locale = useContext(LocaleContext)
  const [isCalendarShown, setCalendarShown] = useState()
  const showCalendar = () => setCalendarShown(true)
  const hideCalendar = () => setCalendarShown(false)

  return (
    <BirthDate>
      <CalendarInput onClick={showCalendar}>
        {!!birthdate && new Date(birthdate).toLocaleDateString('fa-IR')}
      </CalendarInput>
      <LabelExtra>{locale.BIRTH_DATE}</LabelExtra>
      <CalendarIcon src={calendarIcon} alt="" />
      {isCalendarShown &&
        <BottomSheet cancel={hideCalendar}>
          <LabelExtra display="block" bold padding="0 0 10px 0" fontSize="1rem">
            {locale.BIRTH_DATE}
          </LabelExtra>
          <DatePicker
            birthdate={birthdate}
            onChange={onChange}
            hideCalendar={hideCalendar}
          />
        </BottomSheet>
      }
    </BirthDate>
  )
}